var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangle2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert",
    transform: "translate(-598 -10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14028",
    "data-name": "Rectangle 14028",
    width: 32,
    height: 32,
    transform: "translate(598 10)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "warning_black_24dp_2_",
    "data-name": "warning_black_24dp (2)",
    d: "M5.175,26.992H25.541a2.7,2.7,0,0,0,2.34-4.057L17.7,5.341a2.7,2.7,0,0,0-4.679,0L2.836,22.935a2.7,2.7,0,0,0,2.34,4.057Zm10.183-9.466a1.356,1.356,0,0,1-1.352-1.352v-2.7a1.352,1.352,0,1,1,2.7,0v2.7A1.356,1.356,0,0,1,15.358,17.526Zm1.352,5.409h-2.7v-2.7h2.7Z",
    transform: "translate(598.531 11.008)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle2);
export default __webpack_public_path__ + "static/media/alert-triangle-2.3549d74b.svg";
export { ForwardRef as ReactComponent };